// helper function to bind click event
export function onClick (node, cb) {
    node.addEventListener('click', (event) => {
        event.stopPropagation();
        cb();
    });
};

export function onKeyDown(node, cb) {
    node.addEventListener('keydown', (event) => {
        if (event.keyCode === 9  || !event.shiftKey) {
            event.stopPropagation();
            cb();
        }
    });
};

export function onFocus(node, cb) {
    node.addEventListener('focus', (event) => {
        event.stopPropagation();
        cb();
    });
};



// WEBPACK FOOTER //
// ./src/js/utils.js